"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonOverrides = void 0;
var _styles = require("@mui/material/styles");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var buttonOverrides = {
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true
    }
  },
  MuiButton: {
    defaultProps: {
      variant: 'contained'
    },
    styleOverrides: {
      root: function root(_ref) {
        var _objectSpread2;
        var _ref$ownerState$color = _ref.ownerState.color,
          color = _ref$ownerState$color === void 0 ? 'primary' : _ref$ownerState$color,
          _ref$theme = _ref.theme,
          boxShadow = _ref$theme.boxShadow,
          breakpoints = _ref$theme.breakpoints,
          palette = _ref$theme.palette,
          spacing = _ref$theme.spacing,
          transitions = _ref$theme.transitions,
          typography = _ref$theme.typography;
        return _objectSpread(_objectSpread({}, typography.actionBold), {}, (_objectSpread2 = {
          padding: "".concat(spacing(1), " ").concat(spacing(2)),
          transition: transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
            duration: transitions.duration.shorter
          })
        }, _defineProperty(_objectSpread2, breakpoints.up('tablet'), {
          padding: "".concat(spacing(1), " ").concat(spacing(4))
        }), _defineProperty(_objectSpread2, '&.MuiButton-contained', {
          boxShadow: 'none'
        }), _defineProperty(_objectSpread2, '&.MuiButton-contained:not(.Mui-disabled)', _objectSpread({}, color !== 'inherit' && {
          backgroundColor: palette[color].main,
          '&:hover': {
            background: palette[color].dark
          },
          '&:active': {
            background: palette[color].darker // "pressed state"
          }
        })), _defineProperty(_objectSpread2, '&.MuiButton-outlined:not(.Mui-disabled)', _objectSpread({}, color !== 'inherit' && {
          color: palette.common.black,
          border: 'none',
          boxShadow: boxShadow.outline.default,
          // TODO: add "component" token to theme
          '&:hover': {
            boxShadow: palette.action.nonSelectableHoverOutline,
            backgroundColor: 'transparent'
          },
          '&.Mui-focusVisible': {
            // TODO: focus state needs to be added to figma
            boxShadow: palette.action.focusOutline,
            backgroundColor: 'transparent'
          },
          '&:active': {
            backgroundColor: (0, _styles.alpha)(palette.common.black, palette.action.activatedOpacity // TODO: create palette.action.activated = rgba(0, 0, 0, 0.12)
            )
          }
        })), _defineProperty(_objectSpread2, '&.Mui-disabled', {
          color: palette.text.disabled,
          '&.MuiButton-outlined': {
            borderColor: palette.action.disabled
          },
          '&.MuiButton-contained': {
            color: palette.action.disabled,
            backgroundColor: palette.action.disabledBackground
          }
        }), _defineProperty(_objectSpread2, '&.MuiButton-text:not(.Mui-disabled)', _objectSpread({}, color !== 'inherit' && {
          color: palette[color].main,
          '&:hover': {
            color: palette[color].dark,
            backgroundColor: (0, _styles.alpha)(palette.common.black, palette.action.hoverOpacity // TODO: create palette.action.hoverOpacity = rgba(0, 0, 0, 0.05)
            )
          },

          '&:active': {
            color: palette[color].darker,
            // "pressed state"
            backgroundColor: (0, _styles.alpha)(palette.common.black, palette.action.activatedOpacity // TODO: create palette.action.activated = rgba(0, 0, 0, 0.12)
            )
          }
        })), _defineProperty(_objectSpread2, '.MuiButton-startIcon, .MuiButton-endIcon', {
          '.MuiSvgIcon-root': {
            fontSize: 16
          }
        }), _objectSpread2));
      }
    }
  }
};
exports.buttonOverrides = buttonOverrides;